import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { userServices } from "../../Services/user.service";
import CardWrap from "../Common/CardWrap";
import Tooltip from "../Common/Tooltip";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services/global.service";
import { validationService } from "../../Services/validation.service";
import { roles } from "../../Config/Roles";
import {
  email,
  lettersAndNumbers,
  PIN,
  numbersOnly,
  lettersOnly,
  OIB,
} from "../../Config/Regex";
import { AuthContext } from "../../Contexts/AuthContext";
import AsyncSelect from "react-select/async";

export default function AddUser() {
  const { locName, locTenant, locStore } = useContext(GlobalContext);
  const { userId, roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, control, setValue, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const isTempUser = Boolean(watch("tempUser", false));
  console.log("AddUser render, errors:", errors);
  const history = useHistory();

  const { master, admin, support } = roles;

  const [role, setRoles] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [pinType, setPinType] = useState("password");
  const [backUrl, setBackUrl] = useState();
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [tenantObj, setTenantObj] = useState({
    id: null,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const goBack = () => {
    history.push(backUrl);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    switch (locName) {
      case "tenants":
        setBackUrl(`/${locName}/${locTenant}`);
        break;
      case "stores":
        setBackUrl(`/${locName}/${locStore}`);
        break;
      default:
        setBackUrl(`/${locName}`);
    }
    userServices
      .getRoles(Number(roleId))
      .then((res) => setRoles(res.data))
      .catch((err) => console.log(err));
  }, []);

  const onSubmit = (data) => {
    alert("Tu sam");
    userServices
      .create({
        isActive: data.isActive,
        loginName: isTempUser ? "" : data.loginName,
        realName: data.realName,
        printName: isTempUser ? "" : data.printName,
        personalIdentificationNumber: isTempUser
          ? ""
          : data.personalIdentificationNumber,
        phone: isTempUser ? "" : data.phone,
        email: data.email,
        pin: data.pin,
        tempUser: isTempUser,
        tenantId: [master, admin, support].includes(Number(data.roleId))
          ? null
          : Number(tenantObj.id),
        roleId: Number(data.roleId),
        posDiscountEdit: Boolean(data.posDiscountEdit),
        posPriceEdit: Boolean(data.posPriceEdit),
        posProductEdit: Boolean(data.posProductEdit),
        posInvoiceCopyEdit: Boolean(data.posInvoiceCopyEdit),
        posHardReset: Boolean(data.posHardReset),
        posCashierEdit: Boolean(data.posCashierEdit),
        posCodeBookEdit: Boolean(data.posCodeBookEdit),
        posDraftEdit: Boolean(data.posDraftEdit),
        posDuplicateEdit: Boolean(data.posDuplicateEdit),
        posStornoEdit: Boolean(data.posStornoEdit),
        rfidTag: data.RFIDtag,
      })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("AddUser-SuccessModal-Title"),
              text: translator("AddUser-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("AddUser-UnsuccessModal-Title"),
              text: translator("AddUser-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("AddUser-UnsuccessModal-Title"),
          text: translator("AddUser-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        }),
      );
  };

  const handleCancel = () => {
    goBack();
  };

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant),
      )
      .then((res) => {
        if (Number(locTenant) > 0) {
          setValue("tenantId", {
            id: Number(locTenant),
            value: Number(locTenant),
            label: res.data.filter((e) => e.id === Number(locTenant))[0].name,
          });
          setTenantObj({
            id: locTenant,
            value: locTenant,
            label: res.data.filter((e) => e.id === Number(locTenant))[0].name,
          });
        }
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  return (
    <CardWrap
      subtitle={translator("Users-Create-Subtitle-NewUser")}
      backUrl={backUrl}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        {/* <div className="col-lg-12">
          <div className="form-group">
            <label className="labelCont">
              <input
                ref={register}
                type="checkbox"
                name="tempUser"
                defaultChecked={false}
              />
              <span className="checkmark"></span>
            </label>
            <span className="Data">{translator("AddUser-TempUser")}</span>
          </div>
        </div> */}
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Users-Create-Personal-Data")}
            </legend>
            <div className="form-group">
              <div className="form-group">
                <label>{translator("Users-Create-Tenant")}</label>
                <Controller
                  as={AsyncSelect}
                  control={control}
                  autoComplete="off"
                  name="tenantId"
                  placeholder={translator("Select-Tenant")}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                  onChange={function (event) {
                    setTenantObj({
                      id: event[0].id,
                      label: event[0].label,
                      value: event[0].value,
                    });

                    return event[0];
                  }}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                />

                {errors.tenantId && errors.tenantId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("Users-Create-Role")}</label>{" "}
                <Tooltip text={translator("Users-Role-Msg")} />
                <select
                  name="roleId"
                  ref={register({ required: true })}
                  className="form-control"
                >
                  <option value="" selected>
                    {translator("Select-Role")}
                  </option>
                  {role.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {translator(e.name)}
                      </option>
                    );
                  })}
                </select>
                {errors.roleId && errors.roleId.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("Users-Create-Full-Name")}</label>{" "}
                <Tooltip text={translator("Users-FullName-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: lettersOnly,
                  })}
                  name="realName"
                />
                {errors.realName && errors.realName.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.realName && errors.realName.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
                {errors.realName && errors.realName.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("Users-Create-OIB")}</label>{" "}
                <Tooltip text={translator("Users-OIB-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  disabled={isTempUser}
                  ref={register({
                    required: !isTempUser,
                    pattern: isTempUser ? undefined : OIB,
                    validate: isTempUser
                      ? undefined
                      : () =>
                          validationService
                            .validateUserOib(
                              document.getElementsByName(
                                "personalIdentificationNumber",
                              )[0].value,
                            )
                            .then((res) => {
                              console.log("ss1", res);
                              return res === true ? true : false;
                            })
                            .catch((err) => console.log(err)),
                  })}
                  name="personalIdentificationNumber"
                />
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  errors.personalIdentificationNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  errors.personalIdentificationNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-OIBLength")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  errors.personalIdentificationNumber.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-OIBNotValid")}
                    </p>
                  )}
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Users-Create-UserData")}
            </legend>
            <div className="form-group">
              <label>{translator("Users-Create-Print-Name")}</label>{" "}
              <Tooltip text={translator("Users-Create-TooltipPrintNameMsg")} />
              <input
                type="text"
                className="form-control"
                disabled={isTempUser}
                ref={register({
                  required: !isTempUser,
                  pattern: isTempUser ? undefined : lettersAndNumbers,
                  maxLength: isTempUser ? undefined : 20,
                })}
                name="printName"
              />
              {!isTempUser &&
                errors.printName &&
                errors.printName.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {!isTempUser &&
                errors.printName &&
                errors.printName.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersAndNumbers")}
                  </p>
                )}
              {!isTempUser &&
                errors.printName &&
                errors.printName.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength20")}
                  </p>
                )}
            </div>
            <div className="form-row">
              <div className="form-group col-md-6 col-xs-12">
                <label>{translator("Users-Create-Username")}</label>{" "}
                <Tooltip text={translator("Users-UserName-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  disabled={isTempUser}
                  ref={register({
                    required: !isTempUser,
                    pattern: isTempUser ? undefined : lettersAndNumbers,
                    maxLength: isTempUser ? undefined : 20,
                    minLength: isTempUser ? undefined : 4,
                    validate: isTempUser
                      ? undefined
                      : () =>
                          validationService.validateLoginName(
                            document.getElementsByName("loginName")[0].value,
                          ),
                  })}
                  name="loginName"
                />
                {!isTempUser &&
                  errors.loginName &&
                  errors.loginName.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.loginName &&
                  errors.loginName.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-LettersAndNumbers")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.loginName &&
                  errors.loginName.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-User-LoginName")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.loginName &&
                  errors.loginName.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength20")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.loginName &&
                  errors.loginName.type === "minLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MinLength4")}
                    </p>
                  )}
              </div>

              {/* <div className="form-row"> */}
              {/* <div className="form-group col-md-6 col-xs-12">
                <label>{translator("Users-Create-RFIDtag")}</label>{" "}
                <Tooltip text={translator("Users-Create-TooltipRFIDtageMsg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    pattern: numbersOnly,
                    maxLength: 10,
                  })}
                  name="RFIDtag"
                />
                {errors.RFIDtag && errors.RFIDtag.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-NumbersOnly")}
                  </p>
                )}
                {errors.RFIDtag && errors.RFIDtag.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength10")}
                  </p>
                )}
              </div> */}
              <div className="form-group col-md-6 col-xs-12">
                <label>PIN</label>{" "}
                <Tooltip text={translator("Users-Create-TooltipPINMsg")} />
                <input
                  type={pinType}
                  className="form-control"
                  ref={register({
                    required: true,
                    pattern: PIN,
                    validate: (value) =>
                      tenantObj.id
                        ? validationService.validateUserPin(
                            value,
                            tenantObj.id,
                          )
                        : true,
                  })}
                  name="pin"
                />
                <span
                  className="show-pin"
                  onMouseDown={() => setPinType("text")}
                  onMouseUp={() => setPinType("password")}
                  onMouseLeave={() => setPinType("password")}
                  onTouchStart={() => setPinType("text")}
                  onTouchCancel={() => setPinType("password")}
                >
                  <i className="fas fa-eye text-dark"></i>
                </span>
                {errors.pin && errors.pin.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.pin && errors.pin.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PIN")}
                  </p>
                )}
                {errors.pin && errors.pin.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PIN-InUse")}
                  </p>
                )}
              </div>
            </div>
            {/* </div> */}
            <div className="form-group">
              <label>{translator("Users-Create-Phone-Number")}</label>{" "}
              <Tooltip text={translator("Users-PhoneNumber-Msg")} />
              <input
                type="text"
                className="form-control"
                disabled={isTempUser}
                ref={register({
                  required: !isTempUser,
                  pattern: isTempUser ? undefined : numbersOnly,
                  maxLength: isTempUser ? undefined : 20,
                })}
                name="phone"
              />
              {!isTempUser &&
                errors.phone &&
                errors.phone.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {!isTempUser &&
                errors.phone &&
                errors.phone.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PhoneNumber")}
                  </p>
                )}
              {!isTempUser &&
                errors.phone &&
                errors.phone.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength20")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label>Email</label>{" "}
              <Tooltip text={translator("Users-Email-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  pattern: email,
                  maxLength: 50,
                })}
                name="email"
              />
              {errors.email && errors.email.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
              {errors.email && errors.email.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Users-Create-MoreInformation")}
            </legend>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posPriceEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-PriceEditing")}</span>{" "}
              <Tooltip text={translator("Users-PriceEditing-Msg")} />
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posDiscountEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">
                {translator("AddUser-DiscountEditing")}
              </span>{" "}
              <Tooltip text={translator("Users-DiscountEditing-Msg")} />
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posProductEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-ProductEdit")}</span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input
                  ref={register}
                  type="checkbox"
                  name="posInvoiceCopyEdit"
                />
                <span className="checkmark"></span>
              </label>
              <span className="Data">
                {translator("AddUser-InvoiceCopyEdit")}
              </span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posHardReset" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-HardReset")}</span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posCashierEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-CashierEdit")}</span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posCodeBookEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-CodeBookEdit")}</span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posDraftEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-DraftEdit")}</span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posDuplicateEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">
                {translator("AddUser-DuplicateEdit")}
              </span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input ref={register} type="checkbox" name="posStornoEdit" />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-StornoEdit")}</span>
            </div>
          </fieldset>
        </div>
        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
